export enum RoutePaths {
  RIAM = "riam",
  PRE_QUALIFICATION = "pre-qualification"
}
